export const unsafeInputPattern = /<[^>]*script|<\/?[^>]+(>|$)/gi; // matches HTML tags and <script>

// Prevents HTML tags or script injections
export function isSafeInput(input: string): boolean {
    return !unsafeInputPattern.test(input);
}